import {combineReducers} from "redux";
import bdaStateSlice from "./bdaStateSlice";

const reducer = combineReducers({
    bdaState: bdaStateSlice,
});


export default reducer;
